import { createAction } from '@reduxjs/toolkit';
import { INavigate, types } from './types';

export const navigate = createAction<INavigate>(types.NAVIGATE);
